export const emailPattern = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/

export const phonePattern = /^\+\d{7,}$/

export default emailPattern